<template>
  <div class="page-container" id="overseasWelcome">
    <el-row :gutter="16">
      <el-col :span="18">
        <el-row>
          <el-row
            style="padding: 20px 15px; font-size: 14px"
            class="content-panel border-bottom-line"
          >
            <label style="margin-right: 20px">ETD Nearly:</label>
            <el-radio-group v-model="isActive" @change="changeHandler">
            <el-radio label="6">6 MONTHS</el-radio>
            <el-radio label="3">3 MONTHS</el-radio>
            <el-radio label="1">1 MONTHS</el-radio>
            </el-radio-group>
            <label style="float: right; color: #4ab4fe; font-size: 13px" @click="changMoreInfoVisible"
              >MORE</label
            >
            <el-row v-show="moreInfoVisible" :gutter="24" class="marginTop">
              <el-form>
                <el-col :span="1" class="displayCenter">ETD</el-col>
                <el-col :span="6">
                    <el-form-item label="From:">
                        <el-date-picker
                            v-model="etdStart"
                            type="date"
                            style="width: 100%"
                            align="right"
                            size="mini"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>

                </el-col>
               <el-col :span="6">
                    <el-form-item label="To:">
                        <el-date-picker
                            v-model="etdEnd"
                            type="date"
                            style="width: 100%"
                            align="right"
                            size="mini"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期"
                            >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="2" class="displayCenter">
                  <el-button type="primary" class="el-button-search" @click="searchData">search</el-button>
                </el-col>
                </el-form>
            </el-row>
          </el-row>
          <el-row>
            <el-row
              style="background-color: #f9fafc; padding: 10px 15px"
              class="content-panel border-bottom-line"
            >
              <label class="total-title">Total Comfirmed Credit Amount:</label>
              <label class="all-num">{{ TCCA.all?'$'+TCCA.all:'' }}</label>
            </el-row>
            <el-row
              class="content-panel border-bottom-line"
              style="padding: 5px 15px 20px 15px; color: #fff"
            >
              <div class="progress-bar">
                <div
                 v-if="TCCA.left!==0"
                  class="left-bar"
                  :style="{
                    width: TCCA.all?(TCCA.left / (TCCA.left + TCCA.right)) * 100 + '%':50+'%',
                  }"
                >
                  <div class="left-title">Paid</div>
                  <div :class="[TCCA.all?'left-progress':'left-progress-null']">{{ TCCA.left?'$'+TCCA.left:'' }}</div>
                </div>
                <div
                  v-if="TCCA.right!==0"
                  class="right-bar"
                  :style="{
                    width: TCCA.all?(TCCA.right / (TCCA.left + TCCA.right)) * 100 + '%':50+'%',
                  }"
                >
                  <div class="right-title">Unpaid</div>
                  <div :class="[TCCA.all?'right-progress':'right-progress-null']">{{ TCCA.right?'$'+TCCA.right:'' }}</div>
                </div>
              </div>
            </el-row>
          </el-row>
          <el-row>
            <el-row
              style="background-color: #f9fafc; padding: 10px 15px"
              class="content-panel border-bottom-line"
            >
              <label class="total-title">Total Credit Amount:</label>
              <label class="all-num">{{ TCA.all?'$'+TCA.all:''}}</label>
            </el-row>
            <el-row
              class="content-panel border-bottom-line"
              style="padding: 5px 15px 20px 15px; color: #fff"
            >
              <div class="progress-bar">
                <div
                 v-if="TCA.left!==0"
                  class="left-bar"
                  :style="{
                    width: TCA.all? (TCA.left / (TCA.left + TCA.right)) * 100 + '%':50+'%',
                  }"
                >
                  <div class="left-title">Confirmed</div>
                  <div :class="[TCA.all?'left-progress':'left-progress-null']">{{ TCA.left?'$'+TCA.left:'' }}</div>
                </div>
                <div
                  v-if="TCA.right!==0"
                  class="right-bar"
                  :style="{
                    width:TCA.all? (TCA.right / (TCA.left + TCA.right)) * 100 + '%' :50+'%',
                  }"
                >
                  <div class="right-title">Unconfirmed</div>
                  <div :class="[TCA.all?'right-progress':'right-progress-null']"><span>{{ TCA.right?'$'+TCA.right:'' }}</span></div>
                </div>
              </div>
            </el-row>
          </el-row>
          <el-row>
            <el-row
              style="background-color: #f9fafc; padding: 10px 15px"
              class="content-panel border-bottom-line"
            >
              <label class="total-title">Total Order Qualtity:</label>
              <label class="all-num">{{ TOQ.all?TOQ.all:'' }}</label>
            </el-row>
            <el-row
              class="content-panel"
              style="padding: 5px 15px 20px 15px; color: #fff"
            >
              <div class="progress-bar">
                <div v-if="TOQ.left!==0"
                  class="left-bar"
                  :style="{
                    width: TOQ.all?(TOQ.left / (TOQ.left + TOQ.right)) * 100 + '%':50+'%',
                  }"
                >
<!--                  <div class="left-title">Paid</div>-->
                  <div :class="[TOQ.all?'left-progress green-bar':'left-progress-null']">
                    {{ TOQ.left?TOQ.left+'orders':'' }}
                  </div>
                </div>
                <div v-if="TOQ.right!==0"
                  class="right-bar"
                  :style="{
                    width: TOQ.right?(TOQ.left / (TOQ.left + TOQ.right)) * 100 + '%':50+'%',
                  }"
                >
<!--                  <div class="right-title">Unpaid</div>-->
                  <div :class="[TOQ.all?'right-progress':'right-progress-null']">{{ TOQ.right?TOQ.right+'orders':'' }} </div>
                </div>
              </div>
            </el-row>
          </el-row>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-row
            style="
              background-color: #f9fafc;
              padding: 15px 0 15px 15px;
              font-weight: 600;
            "
            class="content-panel border-bottom-line"
            >OVERSAE AGENT COMPANY———{{ custName }}</el-row
          >
          <el-row
            :gutter="4"
            class="content-panel GIA-panel border-bottom-line"
          >
            <div style="float: left; flex: 2"><span style="font-weight: bold">GST No.:</span></div>
            <div style="float: left; flex: 2"><span style="font-weight: bold">IEC No.:</span></div>
            <div style="float: right; flex: 3">
              <span style="font-weight: bold">Address: </span>{{merchantsInfo.addrCn}}
            </div>
          </el-row>
          <el-row>
            <el-col :span="12" style="border-right: 1px solid #e8eaeb">
              <el-row class="content-panel">
                <el-row style="color: #4ab4fe"
                  ><span
                    ><img
                      src="../../assets/images/add_imgs/customer.png"
                      alt=""
                      srcset="" /></span
                  ><span style="margin-left: 5px"
                    >Customer Service:</span
                  ></el-row
                >
                <el-row class="info-item"><span style="font-weight: bold">Name:</span> {{bizInfo.contactCn}}</el-row>
                <el-row class="info-item"><span style="font-weight: bold">Email:</span> {{bizInfo.email}}</el-row>
                <el-row class="info-item"><span style="font-weight: bold">Tel:</span> {{bizInfo.tel}} </el-row>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row class="content-panel">
                <el-row style="color: #4ab4fe"
                  ><span
                    ><img
                      src="../../assets/images/add_imgs/financial.png"
                      alt=""
                      srcset="" /></span
                  ><span style="margin-left: 5px"
                    >Finance:</span
                  ></el-row
                >
                <el-row class="info-item"><span style="font-weight: bold">Name:</span> {{finTnfo.contactCn}}</el-row>
                <el-row class="info-item"><span style="font-weight: bold">Email:</span> {{finTnfo.email}}</el-row>
                <el-row class="info-item"><span style="font-weight: bold">Tel:</span> {{finTnfo.tel}}</el-row>
              </el-row>
            </el-col>
          </el-row>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-row style="background-color: #f9fafc" class="content-panel"
            >CONTRACT SUMMARY:</el-row
          >
          <el-row style="padding: 40px 0" class="content-panel"> </el-row>
        </el-row>
      </el-col>
      <el-col :span="6">
        <el-row v-for="(item, index) in csCustSales">
          <el-row class="title-panel summary border-bottom-line"
            >{{ item.custNameEn }}</el-row
          >
          <el-row class="content-panel" style="padding: 10px 0px 22px 0px">
            <el-row style="padding: 5px 0">
              <el-row class="content-panel">
                <el-row style="color: #4ab4fe; font-weight: bold"
                  ><span
                    ><img
                      src="../../assets/images/add_imgs/customer.png"
                      alt=""
                      srcset="" /></span
                  ><span style="margin-left: 5px"
                    >Customer Service:</span
                  ></el-row
                >
                <el-row class="info-item"><span style="font-weight: bold">Name:</span> {{item.salesObizInfo.salesNameEn}}</el-row>
                <el-row class="info-item"><span style="font-weight: bold">Email:</span> {{item.salesObizInfo.email}}</el-row>
                <el-row class="info-item"><span style="font-weight: bold">Tel:</span> {{item.salesObizInfo.tel}} </el-row>
                <el-row class="info-item"><span style="font-weight: bold">wechat:</span> {{item.salesObizInfo.wechat}}</el-row>
              </el-row>
            </el-row>
            <el-row style="padding: 5px 0">
              <el-row class="content-panel">
                <el-row style="color: #86b867; font-weight: bold"
                  ><span
                    ><img
                      src="../../assets/images/add_imgs/financial.png"
                      alt=""
                      srcset="" /></span
                  ><span style="margin-left: 5px">Finance:</span></el-row
                >
                <el-row class="info-item"><span style="font-weight: bold">Name:</span> {{item.salesOfinInfo.salesNameEn}}</el-row>
                <el-row class="info-item"><span style="font-weight: bold">Email:</span> {{item.salesOfinInfo.email}}</el-row>
                <el-row class="info-item"><span style="font-weight: bold">Tel:</span> {{item.salesOfinInfo.tel}}</el-row>
                <el-row class="info-item"><span style="font-weight: bold">wechat:</span> {{item.salesOfinInfo.wechat}}</el-row>
              </el-row>
            </el-row>
          </el-row>
        </el-row>
<!--        <el-row style="margin-top: 30px">-->
<!--          <el-row class="title-panel summary border-bottom-line"-->
<!--            >CTS-XIAMEN CONTACTS</el-row-->
<!--          >-->
<!--          <el-row class="content-panel" style="padding: 10px 0px 22px 0px">-->
<!--            <el-row style="padding: 5px 0">-->
<!--              <el-row class="content-panel">-->
<!--                <el-row style="color: #4ab4fe; font-weight: bold"-->
<!--                  ><span-->
<!--                    ><img-->
<!--                      src="../../assets/images/add_imgs/customer.png"-->
<!--                      alt=""-->
<!--                      srcset="" /></span-->
<!--                  ><span style="margin-left: 5px"-->
<!--                    >Customer Service:</span-->
<!--                  ></el-row-->
<!--                >-->
<!--                <el-row class="info-item">Name:</el-row>-->
<!--                <el-row class="info-item">Email:</el-row>-->
<!--                <el-row class="info-item">Tel: </el-row>-->
<!--                <el-row class="info-item">wechat: </el-row>-->
<!--              </el-row>-->
<!--            </el-row>-->
<!--            <el-row style="padding: 5px 0">-->
<!--              <el-row class="content-panel">-->
<!--                <el-row style="color: #86b867; font-weight: bold"-->
<!--                  ><span-->
<!--                    ><img-->
<!--                      src="../../assets/images/add_imgs/financial.png"-->
<!--                      alt=""-->
<!--                      srcset="" /></span-->
<!--                  ><span style="margin-left: 5px">Finance:</span></el-row-->
<!--                >-->
<!--                <el-row class="info-item">Name:</el-row>-->
<!--                <el-row class="info-item">Email:</el-row>-->
<!--                <el-row class="info-item">Tel: </el-row>-->
<!--                <el-row class="info-item">wechat: </el-row>-->
<!--              </el-row>-->
<!--            </el-row>-->
<!--          </el-row>-->
<!--        </el-row>-->
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryCreditInfo, queryCsCustInfo } from "@/api/overseas";
export default {
  name: "overseasWelcome",
  components: {},
  data() {
    return {
      moreInfoVisible: false,
      TCCA: { left: '', right: '', all: '' },
      TCA: { left: '', right: '', all: '' },
      TOQ: { left: '', right: '', all: '' },
      isActive: "6",
      etdEnd: '',
      etdStart: '',
      dataInfo: {},
      merchantsInfo: {},
      finTnfo: {},
      bizInfo: {},
      csCustSales: [],
      custId: '',
      custName: ''
    };
  },
  mounted() {
    let userInfo=JSON.parse(localStorage.getItem('userInfo'))
    this.custId = userInfo.custId;
    this.custName = userInfo.custName;
    var creditParam = {
      /* settleAgentId: "6843204958103347200", */
       settleAgentId: this.custId,
      mouths: this.isActive,
    };

   /*  var i = { csCustId: "6858783814879989760" }; */
    var csCustParam = { csCustId: this.custId };
    this.queryCredit(creditParam)
    this.queryCsCust(csCustParam)
    this.getMenu();
  },
  async created() {},
  beforeDestroy() {},
  methods: {
        getMenu() {
      let self = this;
      self.$store.dispatch("user/getMenu").then((res) => {
        console.log(self.$store.state.user.rightRouters);
      });
    },
    queryCredit(data){
      let self = this;
      if(data.settleAgentId){
      queryCreditInfo(data).then((result) => {
      console.log(result);
        self.dataInfo = result.records;
        self.TCCA.left = self.dataInfo.confirmedTotalAmount;
        self.TCCA.right = self.dataInfo.unConfirmedTotalAmount;
        self.TCCA.all = self.TCCA.left + self.TCCA.right;

        self.TCA.left = self.dataInfo.totalAmountE;
        self.TCA.right = self.dataInfo.totalAmountD;
        self.TCA.all = self.TCA.left + self.TCA.right

        self.TOQ.left = self.dataInfo.allocableOrderQualtity;
        self.TOQ.right = self.dataInfo.allocatedOrderQualtity;
        self.TOQ.all = self.TOQ.left + self.TOQ.right
    });
     }else{
       this.$coreMethods.message(
           "warning",this.$t('message.noMerchantFound'));
     }
    },
    queryCsCust(data){
      if(data.csCustId){
     queryCsCustInfo(data).then((result) => {
      console.log(result);
      this.merchantsInfo = result.records
      var csCustContacts = result.records.csCustContacts;
      var csCustVOs = result.records.csCustVOs;
      // var csCustSales = result.records.csCustVOs.csCustSales;
      console.log(csCustContacts);
      if(csCustContacts){
        for(var a=0; a<csCustContacts.length; a++){
         if(csCustContacts[a].contactType==='OBIZ'){
           this.bizInfo = csCustContacts[a]
            console.log(this.bizInfo.tel)
         }
         if(csCustContacts[a].contactType==='OFIN'){
           this.finTnfo = csCustContacts[a]
            console.log(this.finTnfo)
         }
        }
      }
      if(csCustVOs) {
        csCustVOs.forEach(x => {
          var csCustSaleInfo = {
            custNameEn: x.custNameEn,
            salesObizInfo: {},
            salesOfinInfo: {}
          };
          if(x.csCustSales) {
            x.csCustSales.forEach(item => {
              if (item.salesRole === "OBIZ") csCustSaleInfo.salesObizInfo = item;
              if (item.salesRole === "OFIN") csCustSaleInfo.salesOfinInfo = item;
            })
          }
          this.csCustSales.push(csCustSaleInfo);
        })
      }
/*       this.bizInfo = csCustContacts.filter((item) => item.contactType==='BIZ')
      this.finTnfo = csCustContacts.filter((item) => item.contactType==='FIN')
     console.log(this.bizInfo) */
     /* debugger */
    });
       }else{
        /*   this.$coreMethods.message(
           "warning",this.$t('message.noMerchantFound')); */
       }
    },
    changMoreInfoVisible(){
      this.moreInfoVisible =!this.moreInfoVisible
    },
    searchData(){
     var creditParam = {
         settleAgentId: this.custId,
         etdStart: this.etdStart,
         etdEnd: this.etdEnd
    };
    this.queryCredit(creditParam)
    },
    changeHandler(){
        console.log(this.isActive)
        var creditParam = {
        settleAgentId: this.custId,
        mouths: this.isActive,
    };
        var csCustParam = { csCustId: this.custId };
        this.queryCredit(creditParam)
        this.queryCsCust(csCustParam)
    }
/*     getTime(date){
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      let D = date.getDate() + ' ';
      this.Time = Y+M+D;
      return this.Time
    },
    changeEtdStart() {
      let self = this;
      console.log(self.etdStart)
       self.etdStart = self.getTime(self.etdStart)
       console.log(self.etdStart)
    }, */
  },
};
</script>
<style scoped lang="scss">
#overseasWelcome {
  font-size: 14px;
}
.content-panel {
  border-bottom-left-radius: unset;
  border-bottom-right-radius: unset;
  margin-bottom: unset;
}
.greyForm {
  background-color: #f9fafc;
  padding: 10px 0;
}
.left-bar {
  text-align: center;
  width: 80%;
}
.right-bar {
  margin-left: 5px;
  text-align: center;
  width: 20%;
}
.right-progress-null{
 background-color: #db0303;
  height: 35px;
  border-radius: 5px;
  line-height: 35px;
}
.left-progress-null{
  background-color: #db0303;
  height: 35px;
  border-radius: 5px;
  line-height: 35px;
  font-weight: bold;
}
.left-progress {
  background-color: #4ab4fe;
  height: 35px;
  border-radius: 5px;
  line-height: 35px;
  font-weight: bold;
}
.right-progress {
  background-color: #ff568e;
  height: 35px;
  border-radius: 5px;
  line-height: 35px;
}
.green-bar {
  background-color: #85cc5a;
}
.progress-bar {
  display: flex;
}
.GIA-panel {
  display: flex;
  margin: unset;
}
.content-panel {
  padding: 10px 15px;
}
.info-item {
  margin: 5px 0 5px 22px;
  font-size: 13px;
  color: #353535;
}
.el-tabs--border-card > .el-tabs__content {
  padding: unset;
}
.title-panel {
  margin: unset;
}
.summary {
  padding: 20px 5px;
  background-color: #f9fafc;
  color: #353535;
  font-weight: bold;
}
.border-bottom-line {
  border-bottom: 1px solid #e8eaeb;
}
.left-title,
.right-title {
  color: #353535;
  font-size: 13px;
  margin-bottom: 3px;
}
.total-title {
  padding-right: 10px;
  color: #353535;
}
.all-num {
  color: #fe4a4a;
  font-size: 18px;
}
.displayCenter,.marginTop{
  margin-top: 18px;
}
</style>
